import { TOOL_CHOOSER } from '@/mocks/compare';
import { SectionHeading } from './ui';

export default function ToolChooser({ onSelect }: { onSelect: (anchor: string) => void }) {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Hướng dẫn"
        title="Khi nào nên dùng công cụ nào?"
        subtitle="Chọn công cụ phù hợp với nhu cầu so sánh của bạn."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        {TOOL_CHOOSER.map((t) => (
          <div key={t.anchor} className="flex flex-col rounded-2xl border border-slate-200/80 bg-slate-50/50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
              <i className={`${t.icon} text-lg`} />
            </span>
            <span className="mt-3 text-[10px] font-semibold uppercase tracking-wide text-violet-600">{t.tag}</span>
            <h4 className="mt-1 text-sm font-bold text-slate-800">{t.title}</h4>
            <p className="mt-1.5 text-xs leading-relaxed text-slate-500">{t.desc}</p>
            <button
              type="button"
              onClick={() => onSelect(t.anchor)}
              className="mt-4 w-full whitespace-nowrap rounded-lg bg-violet-600 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-violet-700"
            >
              {t.cta}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}